import React from 'react';
import { Auth } from 'aws-amplify';
import { MetricsForJumboEvent } from '../../../../analytics/constants';
import { LifelineLogoutEvent } from '../../../../analytics/login-logout/events';
import { useSelector } from 'react-redux';
import { isUserLogged } from '../../../../App';
import { redirectToLogin } from '../../../../utils/UtilFunctions';
import { googleLogout } from '@react-oauth/google';

const handleSignout = (agentDetails) => {
  const { external_user_id, crm_user_id, email_id, name } = agentDetails || {};

  sessionStorage.setItem(isUserLogged, false);

  LifelineLogoutEvent({
    [MetricsForJumboEvent.customer_id]: external_user_id,
    [MetricsForJumboEvent.feature_meta]: {
      agent_id: external_user_id,
      crm_user_id,
      email_id,
      name: name,
    },
  });

  // FIXME: this function has been written multiple time merge it
  Promise.all([
    Auth.currentAuthenticatedUser()
      .then(() => {
        return Auth.signOut();
      })
      .catch(() => {
        // do nothing
      }),
    fetch('/api/crm_proxy/lifeline_apis/auth/logout', {
      method: 'POST',
    }).then(() => {
      googleLogout();
      // send relative url with encoding as argument to redirectToLogin
      redirectToLogin(
        encodeURIComponent(
          `${window.location.pathname}${window.location.search}`,
        ),
      );
    }),
  ]);
};

const Logout = () => {
  const { userDetails } = useSelector((state) => ({
    userDetails: state.authState?.userDetails,
  }));
  return (
    <div
      className='tw-py-1 tw-w-full tw-font-medium tw-text-grey-700 tw-cursor-pointer '
      onClick={() => handleSignout(userDetails)}
    >
      Logout
    </div>
  );
};

export { Logout, handleSignout };
